export default {
  primary: {
    light: "#FFB950",
    main: "#002F6E",
    dark: "#EA7000",
    contrastText: "#ffffff"
  },
  secondary: {
    light: "#EDEDED",
    main: "#FFAC31",
    dark: "#EDEDED",
    contrastText: "#ffffff"
  },
  tertiary: {
    light: "#fff",
    dark: "#EDEDED"
  },
  info: {
    main: "#2A9CB7"
  },
  success: {
    main: "#479F4B",
    dark: "#EDEDED"
  },
  error: {
    light: "#EDEDED",
    main: "#D13135",
    dark: "#EDEDED"
  }
};
